import axios from 'axios';
import { getDeviceIdFromSession } from './deviceStorage';
export function setupDeviceInterceptor() {
    axios.interceptors.request.use(config => {
        const deviceId = getDeviceIdFromSession();
        if (deviceId) {
            config.headers['device-id'] = deviceId;
        }
        return config;
    }, error => {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
    });
}
export function initializeDeviceInterceptor() {
    setupDeviceInterceptor();
}
